import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { runtimeCss as _runtimeCss, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
import React from 'react';
// eslint-disable-next-line import/no-cycle
import { useGridContext } from './context';
interface RowSet extends HtmlPropsNoRef<HTMLDivElement> {
  breakpoints: {
    [key: string]: {
      between: number;
    };
  };
}
const RowSet = ({
  breakpoints,
  ...props
}: RowSet): JSX.Element => {
  const {
    breakpoints: outerBreakpoints
  } = useGridContext();
  const css = React.useMemo(() => ({
    ...Object.fromEntries(Object.entries(breakpoints).map(([selected, {
      between
    }]) => {
      const {
        query
      } = outerBreakpoints[selected];
      return [query, {
        // Fixes gap property not working outside of display:grid in > 2020ish versions of Safari
        '&>*:not(style)~*:not(style)': {
          marginTop: `${between}px`
        }
      }];
    })),
    width: '100%',
    margin: 'auto'
  }), [breakpoints, outerBreakpoints]);
  return <div {..._mergeProps({
    css: _runtimeCss(css)
  }, props)} />;
};
export default RowSet;